import * as RadixSwitch from "@radix-ui/react-switch";
import type { JSX } from "react";

import { cn } from "@/lib/cn";

const CONTROL_FOCUS =
  "focus-visible:outline-none focus-visible:shadow-halo disabled:cursor-not-allowed disabled:opacity-50";

export interface SwitchProps {
  checked: boolean;
  onCheckedChange: (next: boolean) => void;
  label: string;
  disabled?: boolean | undefined;
}

/** On/off setting that takes effect at once. For a setting saved with a form, use a checkbox. */
export function Switch({ checked, onCheckedChange, label, disabled = false }: SwitchProps): JSX.Element {
  return (
    <RadixSwitch.Root
      checked={checked}
      disabled={disabled}
      aria-label={label}
      onCheckedChange={onCheckedChange}
      className={cn(
        "inline-flex h-5 w-9 shrink-0 items-center rounded-pill border border-transparent bg-control p-0.5 transition-colors duration-fast ease-token data-[state=checked]:bg-control-on",
        CONTROL_FOCUS,
      )}
    >
      <RadixSwitch.Thumb className="block size-4 rounded-pill border border-line bg-surface transition-transform duration-fast ease-token data-[state=checked]:translate-x-4" />
    </RadixSwitch.Root>
  );
}
